import React, { useEffect } from "react"
import {
    CONSULTING_ADVISORY_SERVICES,
    TEAM_AUGMENTATION_SERVICES,
} from "../../data/home/core-services"
import { OurCases } from "../../features/our-cases"
import { OurClients } from "../../features/our-clients"
import { ScrollableCards } from "../../features/scrollable-cards"
import { HomeIcons } from "../../features/icons"
import { VideoBlock } from "../../features/video-block"
import { CompaniesIcons } from "../../features/icons/subcomponents/IconsCompanies"
import { Gallery } from "../../features/gallery"
import { Helmet } from "react-helmet-async"
import { ITConsultingAndAdvisoryRoute, TeamAugmentationRoute } from "../../routes"
import "./index.scss"

const Home = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <Helmet defer={false}>
                <title>Newsoft</title>
            </Helmet>
            <div className="home">
                <div className="home-title">
                    <p className="t-s2">
                        <span className="t-s1-m">Software development</span>{" "}
                        company providing businesses with top-notch
                        <span className="t-s1-m"> tech talent</span> and helping
                        build powerful
                        <span className="t-s1-m"> software products</span>
                    </p>
                </div>
                <HomeIcons />
                <div className="home-core-services">
                    <h1 className="t-h1-m">Our core services</h1>
                    <ScrollableCards
                        link={TeamAugmentationRoute.path}
                        scrollHeader="Team Augmentation Services"
                        cardsArray={TEAM_AUGMENTATION_SERVICES}
                    />
                    <ScrollableCards
                        link={ITConsultingAndAdvisoryRoute.path}
                        scrollHeader="IT Consulting & Advisory Services"
                        cardsArray={CONSULTING_ADVISORY_SERVICES}
                    />
                </div>
                <VideoBlock />
                <div className="home-icons">
                    <CompaniesIcons />
                </div>
                <OurCases />
                <OurClients />
                <Gallery />
            </div>
        </>
    )
}

export default Home
